import { render, staticRenderFns } from "./tab-content.vue?vue&type=template&id=5d235b28&"
import script from "./tab-content.vue?vue&type=script&lang=js&"
export * from "./tab-content.vue?vue&type=script&lang=js&"
import style0 from "./tab-content.vue?vue&type=style&index=0&id=5d235b28&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports